import dayjs from 'dayjs'
import Icon from '~components/ui/icon'
import FormattedAnswerText from '~components/ui/formatted-answer-text'
import Vet from '~models/vet'
import VetAvatar from './vet-avatar'

type VetAnswerProps = Readonly<{
  answer: string
  createdAt: string
  vet?: Vet.Level1 | null
}>

export const VetAnswer = ({ vet, answer, createdAt }: VetAnswerProps) => {
  return (
    <>
      <div className="flex items-center flex-gap-x-4 p-5">
        <VetAvatar vetThumbnail={vet?.photo_url || ''} />
        <div>
          <div className="mt-1 flex items-center flex-gap-x-2 text-gray-900 text-title-3 dark:text-white">
            {vet?.title || 'Unknown'}
            <Icon name="badge" className="h-5 w-5 fill-primary-500" />
          </div>
          <div className="text-gray-500 text-body-2">Dr.Tail Vet</div>
        </div>
      </div>
      <p className="px-5 py-1 text-gray-900 text-body-2 lg:text-body-3 dark:text-white">
        <FormattedAnswerText text={answer} />
      </p>
      <p className="block px-5 py-2 text-gray-500 text-body-3 lg:pb-5 lg:pt-2">
        {dayjs(createdAt).format('MMM DD, YYYY')}
      </p>
    </>
  )
}

export default VetAnswer
